import { render, staticRenderFns } from "./mainFormView.vue?vue&type=template&id=74e9fed4&"
import script from "./mainFormView.vue?vue&type=script&lang=js&"
export * from "./mainFormView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports